<template>
  <div @click="emitSelected">
    <div :class="'mb-2 p-2 timeFrame ' + getTimeFrameClass()">
      <div>
        <div class="actionItem" @click.prevent="emitDelete">
          <a href="#"><i class="fa-solid fa-trash-can"></i></a>
        </div>
      </div>
      <div>
        {{ timeFrame.startDate | moment("hh:mmA") }} -
        {{ timeFrame.endDate | moment("hh:mmA") }}
        <br />
        {{ dateService.getDuration(timeFrame.startDate, timeFrame.endDate) }}
        hours
      </div>
      <div>
        <div class="actionItem" @click="emitAdd">
          <a href="#"><i class="fa-solid fa-plus"></i></a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: { timeFrame: null, day: null, provider: null },
  inject: ["dateService"],
  methods: {
    getTimeFrameClass() {
      if (this.timeFrame.isMarkedForDelete)
        return "timeFrameInActive timeFrameMarkedForDelete";
      else if (this.timeFrame.isActive) return "timeFrameActive";
      else return "timeFrameInActive";
    },
    emitSelected() {
      this.$emit("select", {
        day: this.day,
        timeFrame: this.timeFrame,
        provider: this.provider,
      });
    },

    emitAdd(e) {
      e.stopPropagation();
      this.$emit("add", {
        day: this.day,
        timeFrame: this.timeFrame,
        provider: this.provider,
      });
    },
    emitDelete(e) {
      e.stopPropagation();
      this.$emit("delete", {
        day: this.day,
        timeFrame: this.timeFrame,
        provider: this.provider,
      });
    },
  },
};
</script>

<style scoped>
.timeFrame {
  border-radius: 2px;
  display: grid;
  grid-template-columns: 1fr 10fr 1fr;
  font-size: 11px;

  align-items: center;
  cursor: pointer;
}

.timeFrameMarkedForDelete {
  opacity: 0.25;
}
.timeFrameActive {
  background-color: #ccffdd;
  border: solid 1px #00e64d;
}

.timeFrameInActive {
  background-color: #ffffb3;
  border: solid 1px #e6e600;
}

.timeFrame:hover * .actionItem {
  display: block;
}

.actionItem {
  display: none;

  padding: 10px;
  background-color: white;
}
</style>
